import queryString from "query-string";

import { LOADS } from "constants/actionTypes";

import { serializeLoads } from "lib/serializers/loads";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";
import { LoadsUrlCreatorProps } from "./types";

function loadsUrlCreator(props: LoadsUrlCreatorProps = {}): string {
  const { action, id, pickupDateGte, pickupDateLte } = props;

  return queryString.stringifyUrl(
    {
      url: urlCheckAndAddIdAndAction("/v2/loads/", id, action),
      query: {
        pickup_date__gte: pickupDateGte,
        pickup_date__lte: pickupDateLte,
      },
    },
    { arrayFormat: "comma" },
  );
}

export const LoadsAction = offlineActionCreator(
  LOADS,
  serializeLoads,
  loadsUrlCreator,
  false,
);
